import { render, staticRenderFns } from "./OverconsumptionChartPanel.vue?vue&type=template&id=66f6648a&scoped=true&"
import script from "./OverconsumptionChartPanel.vue?vue&type=script&lang=js&"
export * from "./OverconsumptionChartPanel.vue?vue&type=script&lang=js&"
import style0 from "./OverconsumptionChartPanel.vue?vue&type=style&index=0&id=66f6648a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f6648a",
  null
  
)

export default component.exports